function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useContext } from 'react';
import './Close.module.scss';
import { Link } from 'react-router-dom';
import cs from 'classnames';
import ButtonLabel from '../../../Buttons/ButtonLabel/ButtonLabel';
import styles from './Close.module.scss';
import ImmersiveHeaderContext from '../ImmersiveHeaderContext/ImmersiveHeaderContext';
export default function Close(_ref) {
  var to = _ref.to,
    onClick = _ref.onClick,
    i18n = _ref.i18n,
    i18nKey = _ref.i18nKey,
    className = _ref.className,
    _ref$relative = _ref.relative,
    relative = _ref$relative === void 0 ? 'route' : _ref$relative;
  var _useContext = useContext(ImmersiveHeaderContext),
    breakpoint = _useContext.breakpoint,
    mode = _useContext.mode;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.returnArrow
  }, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t\t\t@media (max-width: ".concat(breakpoint, "px) {\n\t\t\t\t\t\t.").concat(styles.returnArrow, " {\n\t\t\t\t\t\t\twidth: 40px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t")), relative === 'external' ? /*#__PURE__*/React.createElement("a", {
    href: to,
    onClick: onClick,
    className: cs(styles.returnLink, styles[mode], _defineProperty({}, className, className))
  }, /*#__PURE__*/React.createElement(ButtonLabel, {
    className: styles.returnLinkLabel,
    i18n: i18n,
    i18nKey: i18nKey,
    hideLabel: true
  })) : /*#__PURE__*/React.createElement(Link, {
    to: to,
    onClick: onClick,
    className: cs(styles.returnLink, styles[mode], _defineProperty({}, className, className)),
    relative: relative
  }, /*#__PURE__*/React.createElement(ButtonLabel, {
    className: styles.returnLinkLabel,
    i18n: i18n,
    i18nKey: i18nKey,
    hideLabel: true
  })));
}